import { useEffect, useState } from 'react';
import type { DivergenceIndex } from '../data/types';
import { dataUrl } from './useGraphIndex';

let cache: DivergenceIndex | null = null;
let pending: Promise<DivergenceIndex> | null = null;

async function fetchDivergence(): Promise<DivergenceIndex> {
  if (cache) return cache;
  if (pending) return pending;
  pending = fetch(dataUrl('data/divergence.json'))
    .then((r) => {
      if (!r.ok) throw new Error(`divergence.json ${r.status}`);
      return r.json() as Promise<DivergenceIndex>;
    })
    .then((d) => {
      cache = d;
      pending = null;
      return d;
    })
    .catch((err) => {
      pending = null;
      throw err;
    });
  return pending;
}

export interface DivergenceState {
  data: DivergenceIndex | null;
  error: Error | null;
  loading: boolean;
}

export function useDivergence(): DivergenceState {
  const [state, setState] = useState<DivergenceState>(() => ({
    data: cache,
    error: null,
    loading: cache === null,
  }));

  useEffect(() => {
    if (cache) return;
    let cancelled = false;
    fetchDivergence()
      .then((data) => {
        if (!cancelled) setState({ data, error: null, loading: false });
      })
      .catch((error: Error) => {
        if (!cancelled) setState({ data: null, error, loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
